import React from "react"
import "react-chat-elements/dist/main.css"
import { MessageBox } from "react-chat-elements";


const ChatMessage = ({position = 'left', type = 'text', title = 'John du', text = 'Placeholder text'}) => {
  return (   
    <MessageBox
      position={position}
      type={type}
      title={title}
      text={text}
    />
  )
}


export default ChatMessage
